<template>
  <div v-if="registerBoxShow || isRegistering" class="register" :style="{height: setHeight,top: firstVal}">
    <div class="mask"></div>
    <div class="register-box" :style="{maxHeight: boxMaxHeight}">
      <div class="reg-close" @click="goLogin">×</div>
      <div class="reg-box" :style="{maxHeight: boxMaxHeight}">
      <div class="reg-header">{{headTitle}}</div>
      <div class="reg-content">
        <div v-for="item in regInput" :key="item.id">
          <div class="input-row" v-if="item.fieldType == 'TEXT'">
            <!--<div v-if="item.displayType == 1 && checkhide(item.fieldName) == 1">-->
              <!--<span class="required_mark" v-if="item.required == 1">*</span>&lt;!&ndash;'required|'+item.fieldName&ndash;&gt;-->
              <!--<input class="fullInput" v-validate="'required|'+item.fieldName" :name="item.fieldName" :value="modelObj[item.fieldName]" @blur="inputBlur" @input="oninput($event.target.value, item.fieldName)"  type="text" :placeholder="item.displayName" @keyup.enter="doRegister"/>-->
              <!--<div class="err-box"><span class="error-text">{{ errors.first(item.fieldName) }}</span></div>-->
            <!--</div>-->
            <div v-if="item.displayType == 1 && item.fieldName == 'firstName'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="'required'" name="firstName" v-model="modelObj['firstName']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister" @blur="blurIn"/>
              <div class="err-box" v-show="errors.has('firstName')"><span class="error-text">{{ errors.first('firstName') }}</span></div>
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'lastName'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="'required'" name="lastName" v-model="modelObj['lastName']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister" @blur="blurIn"/>
              <div class="err-box" v-show="errors.has('lastName')"><span class="error-text">{{ errors.first('lastName') }}</span></div>
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'mobile'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input :class="[isReadOnly ? 'hasSend':'canChange',isRegistering==2 ? 'harfInput':'fullInput']" v-validate="{required: true, mobile: true, checkMobile: !isReadOnly}" name="mobile" v-model="modelObj['mobile']" @input="mobileChange" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn" :readonly="isReadOnly == true"/>
              <button class="sendCodeBtn changeMobile" @click="doChangeMobile($event)" v-if="isRegistering == 2">修改手机号</button>
              <div class="err-box" v-show="errors.has('mobile')"><span class="error-text">{{ errors.first('mobile') }}</span></div>
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'emailNew'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="{required: true, emailNew: true}" name="emailNew" v-model="modelObj['emailNew']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn"/>
              <div class="err-box" v-show="errors.has('emailNew')"><span class="error-text">{{ errors.first('emailNew') }}</span></div>
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'enterprise'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="'required'" name="enterprise" v-model="modelObj['enterprise']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn"/>
              <div class="err-box" v-show="errors.has('enterprise')"><span class="error-text">{{ errors.first('enterprise') }}</span></div>
              <!--<div class="err-box"><span class="error-text">{{ errors.first('enterprise') }}</span></div>-->
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'dAddress'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="'required'" name="dAddress" v-model="modelObj['dAddress']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn"/>
              <div class="err-box" v-show="errors.has('dAddress')"><span class="error-text">{{ errors.first('dAddress') }}</span></div>
              <!--<input class="fullInput" v-validate="'addr'" name="addr" v-model="modelObj['addr']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"/>-->
              <!--<div class="err-box"><span class="error-text">{{ errors.first('addr') }}</span></div>-->
            </div>
            <!--<div v-if="item.displayType == 10 ">-->
              <!--<span class="required_mark" v-if="item.required == 1">*</span>-->
              <!--<input class="fullInput" :value="modelObj[item.fieldName]" @input="oninput($event.target.value, item.fieldName)" type="password" :placeholder="item.displayName"/>-->
            <!--</div>-->
            <div v-if="item.displayType == 1 && checkmobile(item.fieldName) == 1 && showVerfiyCode == true && !isReadOnly">
              <span class="required_mark" v-if="item.required == 1">*</span>
              <input class="harfInput" v-validate="{required: true, min:6, checkVerfiyCode:(isRegistering==1 && ifCheckCode) ? true: false}" name="verfiyCode" v-model="verfiyCode" type="text" placeholder="验证码" @keyup.enter="doRegister"  @blur="blurIn"/>
              <button class="sendCodeBtn" :class=" !isSend && isCheck ? 'noSend' : 'hasSend'" @click="c_send_yzm($event)">发送验证码</button>
              <div class="err-box" v-show="errors.has('verfiyCode')"><span class="error-text">{{ errors.first('verfiyCode') }}</span></div>
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'postCode' && showPostCode == true">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="{required: true}" name="postCode" v-model="modelObj['postCode']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn"/>
              <div class="err-box" v-show="errors.has('postCode')"><span class="error-text">{{ errors.first('postCode') }}</span></div>
            </div>
            <div v-if="item.displayType == 1 && item.fieldName == 'country' && showCountry == true">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="{required: true}" name="country" v-model="modelObj['country']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"/>
              <div class="err-box" v-show="errors.has('country')"><span class="error-text">{{ errors.first('country') }}</span></div>
            </div>
          </div>
          <div class="input-row" v-if="item.fieldType == 'LIST'">
            <div v-if="item.displayType == 4 && item.fieldName == 'areaA'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <select class="fullInput" v-validate="'required'" name="areaA" v-model="modelObj['areaA']" :placeholder="item.displayName" @keyup.enter="doRegister"   @blur="blurIn">
                <!--<option value="" disabled selected>{{item.displayName}}</option>-->
                <option v-for="option in item.listOptions" :value="option.optionValue">
                  {{option.optionValue}}
                </option>
              </select>
              <div class="err-box" v-show="errors.has('areaA')"><span class="error-text">{{ errors.first('areaA') }}</span></div>
            </div>
            <div v-if="item.displayType == 4 && item.fieldName == 'zhiwei'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <select class="fullInput" v-validate="'required'" name="zhiwei" v-model="modelObj['zhiwei']" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn">
                <option value="" selected disabled>{{item.displayName}}</option>
                <option v-for="option in item.listOptions" :value="option.optionValue">
                  {{option.option}}
                </option>
              </select>
              <div class="err-box" v-show="errors.has('zhiwei')"><span class="error-text">{{ errors.first('zhiwei') }}</span></div>
            </div>
            <div v-if="item.displayType == 4 && item.fieldName == 'province' && !showCountry && modelObj.areaA == '中国大陆'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <select class="fullInput" v-validate="'required'" name="province" v-model="modelObj['province']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn">
                <option value="" selected disabled>{{item.displayName}}</option>
                <option v-for="option in localProvinces" :value="option.name">
                  {{option.name}}
                </option>
              </select>
              <div class="err-box" v-show="errors.has('province')"><span class="error-text">{{ errors.first('province') }}</span></div>
              <div v-if="cities">
                <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
                <select class="fullInput" v-validate="'required'" name="city" v-model="modelObj['city']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister" @change="updateShowAndPost()"  @blur="blurIn">
                  <option value="" selected disabled>城市</option>
                  <option v-for="option in cities" :value="option.name">
                    {{option.name}}
                  </option>
                </select>
                <div class="err-box" v-show="errors.has('city')"><span class="error-text">{{ errors.first('city') }}</span></div>
              </div>
            </div>
            <div v-if="item.displayType == 4 && item.fieldName == 'province' && modelObj.areaA != '中国大陆' && modelObj.areaA != '其他'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <select class="fullInput" v-validate="'required'" name="province" v-model="modelObj['province']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister"  @blur="blurIn" >
                <option value="" selected disabled>{{item.displayName}}</option>
                <option v-for="option in otherProvinces" :value="option.name">
                  {{option.name}}
                </option>
              </select>
              <div class="err-box" v-show="errors.has('province')"><span class="error-text">{{ errors.first('province') }}</span></div>
              <div v-if="cities">
                <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
                <select class="fullInput" v-validate="'required'" name="city" v-model="modelObj['city']" type="text" :placeholder="item.displayName" @keyup.enter="doRegister" @change="updateShowAndPost()"  @blur="blurIn">
                  <option value="" selected disabled>城市</option>
                  <option v-for="option in cities" :value="option.name">
                    {{option.name}}
                  </option>
                </select>
                <div class="err-box" v-show="errors.has('city')"><span class="error-text">{{ errors.first('city') }}</span></div>
              </div>
            </div>
            <div v-if="item.displayType == 4 && item.fieldName == 'province' && modelObj.areaA == '其他'">
              <span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
              <input class="fullInput" v-validate="'required'" name="province" v-model="modelObj['province']" type="text" placeholder="州省" @keyup.enter="doRegister"  @blur="blurIn" >
              <div class="err-box" v-show="errors.has('province')"><span class="error-text">{{ errors.first('province') }}</span></div>
              <br><span class="required_mark" v-if="item.required == 1">*</span><!--'required|'+item.fieldName-->
                <input class="fullInput" v-validate="'required'" name="city" v-model="modelObj['city']" type="text" placeholder="市县" @keyup.enter="doRegister"   @blur="blurIn">
                <div class="err-box" v-show="errors.has('city')"><span class="error-text">{{ errors.first('city') }}</span></div>
            </div>
          </div>
        </div>
        <div class="register-btn-box">
          <button class="register-btn" @click="doRegister" v-show="isRegistering==2">更新</button>
          <button class="register-btn" @click="doRegister" v-show="registerBoxShow">注册</button>
          <div class="tapRegister"  v-show="registerBoxShow">已有账号，<a @click="goLogin">立即登录</a></div>
        </div>
      </div>
      <div class="reg-footer"></div>
    </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import request from '@/utils/request'
  import bus from '../utils/eventBus';
  import { Validator } from 'vee-validate';
  import {setCookie, getCookie, removeCookie} from '../utils/public';
  import poseCodes from '../assets/Cities.json';
  export default {
    name: 'Register',
    data() {
      return {
        headTitle:"注册",
        registerBoxShow: false,
        regInput: [],
        isSend: false,
        isCheck: false,
        verfiyCode: '',
        ifCheckCode: true,
        showVerfiyCode: false,
        modelObj : {
          firstName: '',
          lastName: '',
          mobile: '',
          emailNew: '',
          enterprise: '',
          addr: '',
          areaA: '中国大陆',
          zhiwei: '',
          province: '',
          city:'',
          postCode: '',
          dAddress:'',
          country:'中国'
        },
        gs: 60,
        loginMobile: '',
        setHeight: $(window).height() + "px",
        firstVal: 0,
        boxMaxHeight: 'auto',
        provinces: [],
        otherProvinces:[],
        localProvinces:[],
        cities: [],
        poseCodes:[],
        showCountry: false,
        showPostCode: false,
        isReadOnly:false
        //token:''
      };
    },
    created() {
      var _self = this;
      $.ajax({ //获取简易表单
        url: window.config.api.gateway.general+'/member/form/GetForNewForm',
        type: 'post',
        dataType: 'json',
        data: {
          "memberFormId": window.config.formId,
          "trackId": 0
        },
        success: function(e){
          _self.regInput = e.body.content.items;
          _self.regInput.forEach(item => {
            if(item.fieldName == 'zhiwei') {
              item.listOptions.forEach(item => {
                switch(item.optionValue) {
                  case 'Director/VP':
                    item.option = '总监/VP/总经理';
                    break;
                  case 'Manager':
                    item.option = '部门经理';
                    break;
                  case 'Project Manager':
                    item.option = '项目经理';
                    break;
                  case 'Engineer':
                    item.option = '工程师';
                    break;
                  case 'Buyer' :
                    item.option = '采购';
                    break;
                  case 'Professor' :
                    item.option = '教授/老师';
                    break;
                  case 'Researcher' :
                    item.option = '研究员';
                    break;
                  case 'Student' :
                    item.option = '学生';
                    break;
                  case 'Other' :
                    item.option = '其它';
                    break;
                  default:
                    break;
                }
              })
            }
          })
          // console.log(e.body.content.items);
          $.ajax({
            url: window.config.api.gateway.general+'/dic/params/getTree',
            type: 'post',
            dataType: 'json',
            data: {
              tenantId:window.config.tenantId,
              dicId:window.config.dicId,
              format:'object'
            },
            success: function(e) {
              _self.provinces = e.body.content[window.config.dicId];
              console.log(_self.provinces);
              _self.postCodes = poseCodes.Cities.City;
              _self.localProvinces = _self.provinces.filter(item => {
                return item.name !='台湾' && item.name != '香港' && item.name != '澳门';
              })
            }
          })
        }
      })
    },
    computed:{
        ...mapState(["isRegistering"]),
        NewArea(){
          return  this.modelObj['areaA']
        },
        NewProvice(){
          return  this.modelObj['province']
        },
        scrollHeight () {
            return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0
        }
    },
    props: ['screenWidth','setTop'],
    mounted() {
      let _this = this;
      bus.$on('registerBoxShow', function(msg) {
        _this.registerBoxShow = msg;
        if(_this.screenWidth > 750){
          _this.firstVal = '0';
        }else {
          _this.firstVal = _this.setTop + "px";
        }
        _this.$nextTick(() => {
          _this.boxMaxHeight = ($('.reg-header').outerHeight() + $('.reg-content').outerHeight())  + 'px';
        });
      });
      Validator.extend('checkMobile', {
          getMessage: () => '您输入的手机号已注册，请登录',
          validate: value => {
              return new Promise(resolve => {
                  $.ajax({
                      url: window.config.api.gateway.general+'/member/checkUnique',
                      type: 'post',
                      dataType: 'json',
                      async: false,
                      data: {
                          "tenantId":window.config.tenantId,
                          /*"memberFormId":window.config.formId,*/
                          "memberSchemaId":window.config.schemaId,
                          "unique": _this.modelObj.mobile,
                          "fieldName":"mobile"
                      },
                      success: function(e){
                          if(e.body.content.result){
                              _this.isCheck = true;
                              return resolve({
                                  valid: true
                              });
                          }else {
                              _this.isCheck = false;
                              return resolve({
                                  valid: false
                              });
                          }
                      }
                  });
              });
          }
      });
      Validator.extend('checkEmail', {
          getMessage: () => '您输入的邮箱已注册，请登录',
          validate: value => {
              return new Promise(resolve => {
                  $.ajax({
                      url: window.config.api.gateway.general+'/member/checkUnique',
                      type: 'post',
                      dataType: 'json',
                      async: false,
                      data: {
                          "tenantId":window.config.tenantId,
                          /*"memberFormId":window.config.formId,*/
                          "memberSchemaId":window.config.schemaId,
                          "unique": _this.modelObj.email,
                          "fieldName":"email"
                      },
                      success: function(e){
                          if(e.body.content.result){
                              return resolve({
                                  valid: true
                              });
                          }else {
                              return resolve({
                                  valid: false
                              });
                          }
                      }
                  });
              });
          }
      });
      Validator.extend('checkVerfiyCode', {
          getMessage: () => '请输入正确的验证码',
          validate: value => {
              return new Promise(resolve => {
                  $.ajax({
                      url: window.config.api.gateway.general+'/member/GetToken',
                      type: 'post',
                      dataType: 'json',
                      async: false,
                      data: {
                          "unique":_this.modelObj.mobile,
                          "checkCode":_this.verfiyCode,
                          "schemaId":window.config.schemaId,
                          "formId":window.config.formId,
                          "action":"register"
                      },
                      success: function(e){
                          // if(e.body.content.result){
                          if(e.body.content.token){
                              //_this.token = e.body.content.token
                              return resolve({
                                  valid: true
                              });
                          }else {
                              return resolve({
                                  valid: false
                              });
                          }
                      }
                  });
              });
          }
      });
    },
    methods: {
      goLogin: function() {
        this.registerBoxShow = false;
        this.modelObj.firstName= '';
        this.modelObj.lastName='';
        this.modelObj.mobile= '';
        this.modelObj.emailNew= '';
        this.modelObj.enterprise= '';
        this.modelObj.addr= '';
        this.verfiyCode= '';
        this.modelObj.areaA = '中国大陆';
        this.modelObj.zhiwei = '';
        this.modelObj.province = '';
        this.modelObj.city = '';
        this.modelObj.postCode = '';
        this.modelObj.dAddress = '';
        this.modelObj.country = '中国';
        this.isCheck = false;
        this.isSend = false;
        this.$store.commit('setIsRegistering', 0)
      },
      mobileChange: function(){
        if(this.modelObj.mobile.length<11){
          this.isCheck = false;
          this.isSend = false;
        }
      },
      checkmobile:function(e){
        if(e == 'mobile'){
          return 1
        }
        return 0;
      },
      c_send_yzm:function(eve){ //发送验证码
        var _self = this;
        if(_self.isSend){
          return false;
        }
        if(!_self.isCheck){
          return false;
        }
        var t = null;

        var targetobj = eve.currentTarget;
        function times(){
          _self.gs--;
          //console.log(eve);
          //console.log(eve.currentTarget);
          targetobj.innerHTML = '重新发送('+_self.gs+'s)';
          _self.isSend = true;

          if(_self.gs > 0 && _self.gs <=60){
            t = setTimeout(times,1000);
          }else if ( _self.gs == 0 ){
            _self.gs = 60;
            clearTimeout(t);
            targetobj.innerHTML = '发送验证码';
            _self.isSend = false;
          }
        }
        if(_self.modelObj.mobile.length == 11){
          if(_self.gs == 60){
            $.ajax({
              url: window.config.api.gateway.general+'/member/sendCheckCode',
              type: 'post',
              dataType: 'json',
              data: {
                "memberSchemaId":window.config.schemaId,
                "unique":_self.modelObj.mobile,
                "action":"register"
              },
              success: function(e){
                //console.log(e);
              }
            })
            times();
          }
        }else if( _self.modelObj.mobile.length <= 11 && _self.modelObj.mobile.length > 0){
          // $.Huimodalalert('请填写手机号码',2000);
        }else if(_self.modelObj.mobile.length ==  0){
          // $.Huimodalalert('请填写手机号码',2000);
        }
      },
      doRegister: function () {
        this.ifCheckCode = false;
        let type= this.isRegistering //1 注册 2补全信息
        /*验证部分*/
        this.$validator.validateAll().then(result => {
          if (result) {
            // do stuff if not valid.
            /*提交数据*/
            var _self = this;
            var regTab = [];

            for(var i = 0;i<_self.regInput.length;i++){
              if(_self.regInput[i].fieldName == 'password'){
                continue;
              }
              if(_self.regInput[i].fieldName == 'name'){
                continue;
              }
              if(_self.regInput[i].fieldName == 'flagx'){
                continue;
              }
              if(_self.regInput[i].fieldName == 'address'){
                continue;
              }

              regTab.push({"fieldName" : _self.regInput[i].fieldName,"value": _self.modelObj[_self.regInput[i].fieldName]});
            }

            regTab.push({"fieldName" : 'name',"value": _self.modelObj.firstName + _self.modelObj.lastName})
            regTab.push({"fieldName" : 'password',"value":'96E79218965EB72C92A549DD5A330112'})
            regTab.push({"fieldName" : 'flagx',"value":'KEE'})
            regTab.push({"fieldName" : 'srcflag',"value": smarket.urlParams.ARC})
            regTab.push({"fieldName" : 'address',"value": _self.modelObj.province + _self.modelObj.city + _self.modelObj.dAddress})
            regTab.push({"fieldName" : 'country',"value": _self.modelObj.country || '中国大陆'})
           // debugger
            let info=this.$store.state.info;
            if(type==1){
              this.registerAction(regTab)
            }else if(type==2){
              if(info.mobile != _self.modelObj.mobile){
                this.registerAction(regTab);
              }else{
                this.updateAction(regTab)
              }
            }
          }
        });

      },
      regLogin:function(mobile){
        var _self = this;
        $.ajax({ //登录
          url: window.config.api.gateway.general+'/member/login',
          type: 'post',
          dataType: 'json',
          data: {
            "tenantId":window.config.tenantId,
            "schemaId":window.config.schemaId,
            "memberFormId":window.config.formId,
            "memberSchemaId":window.config.schemaId,
            "unique":mobile,
            "token":"",
            "password":"96E79218965EB72C92A549DD5A330112",
            "checkCode":"",
            "loginType":"",
            "globalUserId":_self.$store.state.contentId
          },
          success: function(e){
            if(e.body.desc == "successful"){
              setCookie('globalUserId',e.body.content.session,7);
              smarket.cookie.smarketMember(window.config.schemaId, {
                session: e.body.content.session,
                memberId: e.body.content.memberModel.memberId
              }, {expires: 7});
              setCookie('sess',e.body.content.sess,7);

              setCookie('username',e.body.content.memberModel.unique,7);

              $.ajax({ //更新字段
                url: window.config.api.gateway.general+'/api/member/contacts/info/update',
                type: 'post',
                dataType: 'json',
                data: {
                  "memberFormId": window.config.formId,
                  "sess": e.body.content.sess,
                  "formData": [
                    {fieldName:'isKEE',value:'是'},
                    ]
                },
                success: function(e){

                }
              });
              _self.$store.commit('setLoginStatus', 1)
              _self.$store.commit('setUserInfo', e.body.content.memberModel)
              bus.$emit('showToast', "登录成功");
            }
          }
        })
      },
      updateShowAndPost(){
        var city = this.modelObj['city'];
        if(city){
            this.modelObj['postCode'] = this.postCodes.filter(item => {
                return item.CityName == city
            })[0].ZipCode;
        }
        console.log(this.modelObj.postCode)
        console.log(this.modelObj['province'] + this.modelObj['city']);
      },
        //回填信息
      fillData(){
           let info=this.$store.state.info;
           this.modelObj={
               firstName:info.firstName || "",
               lastName:info.lastName || "",
               mobile:info.mobile || "",
               emailNew:info.emailNew || info.email || "",
               enterprise:info.enterprise || "",
               addr:info.addr || "",
               areaA:info.areaA ? info.areaA[0] : "中国大陆",
               zhiwei:info.zhiwei ? info.zhiwei[0] : "",
               province:info.province ? info.province[0] : "",
               city:info.city || "",
               postCode:info.postCode || "",
             dAddress:info["dAddress"] || "",
               country:info.country|| ""
           }
       },
      //更新用户注册信息
      updateAction(regTab){
          let _self=this;
          let apiUrl =window.config.api.gateway.general;
          let params={
              sess:getCookie("sess"),
              tenantId:window.config.tenantId,
              memberFormId:window.config.formId,
              url:window.location.href + '?memberFormId='+window.config.formId+'&configId=150722&memberSchemaId='+window.config.schemaId+'&backUrl=http://p2.smarket.net.cn/sh&tn=98010089_dg&ch=2',
              formData:regTab,
          };
        // debugger
          request.post(`${apiUrl}/api/member/contacts/info/update`,params).then((data)=> {
              bus.$emit('showToast', "更新成功");
              setTimeout(function() {
                  _self.regLogin(_self.modelObj.mobile);//直接登陆
                  _self.registerBoxShow = false;
                  _self.modelObj.firstName= '';
                  _self.modelObj.lastName='';
                  _self.modelObj.mobile= '';
                  _self.modelObj.emailNew= '';
                  _self.modelObj.enterprise= '';
                  _self.modelObj.addr= '';
                  _self.modelObj.areaA = '';
                  _self.modelObj.zhiwei = '';
                  _self.modelObj.province = '';
                  _self.modelObj.city = '';
                  _self.modelObj.postCode = '';
                  _self.modelObj.dAddress = '';
                  _self.modelObj.country = '';
                  _self.verfiyCode= '';
                  _self.isCheck = false;
                  _self.isSend = false;
                  // _self.token = '';
                  _self.$store.commit('setIsRegistering', 0)
              },1000)
          })
      },
      registerAction(regTab){
          let _self=this;
          let apiUrl =window.config.api.gateway.general;
          let params={
              tenantId:window.config.tenantId,
              memberFormId:window.config.formId,
              verificationCode:this.verfiyCode,
              url:window.location.href + '?memberFormId='+window.config.formId+'&configId=150722&memberSchemaId='+window.config.schemaId+'&backUrl=http://p2.smarket.net.cn/sh&tn=98010089_dg&ch=2',
              formData:regTab,
          };
          request.post(`${apiUrl}/member/register`,params).then((data)=>{
              bus.$emit('showToast', "注册成功");
              setTimeout(function() {
                  _self.regLogin(_self.modelObj.mobile);//直接登陆
                  _self.registerBoxShow = false;
                  _self.modelObj.firstName= '';
                  _self.modelObj.lastName='';
                  _self.modelObj.mobile= '';
                  _self.modelObj.emailNew= '';
                  _self.modelObj.enterprise= '';
                  _self.modelObj.addr= '';
                  _self.modelObj.areaA = '中国大陆';
                  _self.modelObj.zhiwei = '';
                  _self.modelObj.province = '';
                  _self.modelObj.city = '';
                  _self.modelObj.postCode = '';
                  _self.modelObj.dAddress = '';
                  _self.modelObj.country = '';
                  _self.verfiyCode= '';
                  _self.isCheck = false;
                  _self.isSend = false;
                  // _self.token = '';
                  _self.$store.commit('setIsRegistering', 0);
                _self.ifCheckCode = false;
              },1000)

              //_self.login_name = e.body.content.memberModel.mobile;
              // for(var j = 0;j<regTab.length;j++){
              //   if(regTab[j].fieldName == 'mobile'){
              //     _self.loginMobile = regTab[j].value;
              //   }
              // }
              // if(_self.custid.length > 1){//是否选中会议注册
              //   _self.regBmLogin(_self.loginMobile);
              // }else{
              //   $.Huimodalalert('注册成功',2000);
              //   _self.regLogin(_self.loginMobile);//直接登陆
              // }
          });
      },
      blurIn(){
        window.scrollTo(0, Math.max(this.scrollHeight - 1, 0))
      },
      doChangeMobile(e){
        this.isReadOnly = false;
      }
    },
    watch:{
        isRegistering(val){
          if(val==2){
              this.headTitle="补全信息";
              this.fillData() //回填用户注册信息
              this.isReadOnly = true;
          }else{
              this.headTitle="注册";
              this.isReadOnly = false;
          }
        },
        NewArea:{
            handler(val, oldVal) {
                if( val && val!=oldVal  ){
                    this.showCountry = false;
                    this.showPostCode = false;
                    if( oldVal ){
                        this.modelObj.province = '';
                        this.modelObj.city = '';
                    }
                    var _self = this;
                    switch(val){
                        case '中国大陆':
                            this.showVerfiyCode = true;
                            this.modelObj.country = '中国';
                            this.localProvinces = this.provinces.filter(item => {
                              return item.name !='台湾' && item.name != '香港' && item.name != '澳门';
                            })
                            break;
                        case '香港':
                        case '澳门':
                        case '台湾':
                            this.modelObj.country = '中国';
                            this.showVerfiyCode = false;
                            this.otherProvinces = this.provinces.filter(item=> {
                                return item.name == val;
                            })
                            Validator.extend('mobile', {
                                getMessage: () => '请输入正确的手机号',
                                validate: value => {
                                    return /^[\+\-]?\d+(\.\d+)?$/.test(value)
                                }
                            });
                            break;
                        case '其他':
                            this.showVerfiyCode = false;
                            this.otherProvinces = [];
                            this.showCountry = true;
                            this.showPostCode = true;
                            this.modelObj.country="";
                            Validator.extend('mobile', {
                                getMessage: () => '请输入正确的手机号',
                                validate: value => {
                                    return /^[\+\-]?\d+(\.\d+)?$/.test(value)
                                }
                            });
                            break;
                    }
                }
            },
            immediate: true,
            deep: true
        },
        NewProvice:{
            handler(val, oldVal) {
                if(val && val!=oldVal ) {
                    var _self = this;
                    var selectedProvince = this.provinces.filter(item => {
                        return item.name == val
                    })
                    if(selectedProvince.length>0){
                        this.cities = selectedProvince[0].child[selectedProvince[0].paramId - 1];
                        console.log(this.cities)
                        this.modelObj['city'] = this.cities[0].name;
                    }
                    this.updateShowAndPost();
                }
            },
            immediate: true,
            deep: true
        }
  }
  };
</script>

<style lang="scss" scoped>
  @media (min-width: 750px) {
    .register {
      position: relative;
      .register-box {
        position: fixed;
        box-sizing: border-box;
        width: 578px;
        min-height: 140px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        z-index: 2;
        .reg-box{
          overflow: auto;
          padding: 0 13px;
          height: 100%;
        }
        .reg-close {
          position: absolute;
          top: -38px;
          right: 0px;
          font-size: 28px;
          color: $codeBg;
          cursor: pointer;
        }

        .reg-header {
          height: 60px;
          border-bottom: 1px solid #edecee;
          padding: 26px 0 0 13px;
          font-size: 18px;
          font-weight: bold;
        }

        .reg-content {
          font-size: 14px;
          padding: 25px 0;
          text-align: center;

          .input-row {
            position: relative;
            input {
              height: 40px;
              line-height: 40px;
              border: 1px solid $inputBoder;
              text-indent: 12px;
              outline: none;
              margin-top: 8px;
            }
            select {
              height: 40px;
              line-height: 40px;
              border: 1px solid $inputBoder;
              text-indent: 12px;
              outline: none;
              margin-top: 8px;
            }
            input::-ms-clear{display:none;}

            .fullInput {
              width: 80%;
            }

            .harfInput {
              width: 57%;
              vertical-align: middle;
            }
            .required_mark {
              color: $commonRed;
              position: absolute;
              left: 40px;
              margin-top: 20px;
            }

            .sendCodeBtn {
              width: 23%;
              height: 40px;
              color: #fff;
              border: 0;
              outline: none;
              cursor: pointer;
              vertical-align: middle;
              margin-top: 8px;
            }
            .changeMobile {
              color:$commonRed;
            }
            .hasSend {
              background-color: $codeBg;
            }
            .canChange {
              background-color:#fff;
            }
            .noSend {
              background-color: $commonRed;
            }
            .err-box{
              text-align: left;
              width: 80%;
              margin:  0 auto;
              padding: 8px 0 0 12px;
            }
            .error-text{
              display: block;
              color: $commonRed;
            }
          }

          .register-btn-box {
            text-align: center;
            padding-bottom: 20px;

            .register-btn {
              display: block;
              width: 160px;
              height: 36px;
              color: #fff;
              background-color: $commonRed;
              border: none;
              font-size: 15px;
              margin: 25px auto 13px auto;
              cursor: pointer;
              outline: none;
            }

            .tapRegister {
              color: $color;
              font-size: 13px;
              a {
                cursor: pointer;
                text-decoration: underline;
              }
            }
          }
        }

        .reg-footer {

        }
      }

      .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        background: rgba(0, 0, 0, .5);
      }
    }
  }
  @media (max-width: 750px) {
    .register {
      width: pxToRem(750);
      /*position: relative;*/
      position: absolute;
      top: 0;
      left: 0;
      .register-box {
        position: fixed;
        box-sizing: border-box;
        width: 90%;
        min-height: pxToRem(140);
        left: 50%;
        top: 50px;
        bottom: 60px;
        transform: translate(-50%, 0);
        border-radius: pxToRem(0);
        background: #fff;
        z-index: 2;
        .reg-box{
          overflow: auto;
          padding: 0 pxToRem(30);
          height: 100%;
        }
        .reg-close {
          position: absolute;
          top: pxToRem(-65);
          right: pxToRem(2);
          font-size: pxToRem(50);
          color: $codeBg;
          cursor: pointer;
        }

        .reg-header {
          border-bottom: 1px solid #edecee;
          padding: pxToRem(40) 0 pxToRem(28) pxToRem(45);
          font-size: pxToRem(26);
          font-weight: bold;
          color: $color;
        }

        .reg-content {
          font-size: pxToRem(14);
          padding: pxToRem(25) 0;
          text-align: center;

          .input-row {
            position: relative;
            input {
              border: 1px solid $inputBoder;
              text-indent: pxToRem(18);
              font-size: pxToRem(24);
              padding: pxToRem(16) 0;
              height: pxToRem(66);
              outline: none;
              margin-top: pxToRem(18);
              -webkit-appearance:none;
              border-radius: pxToRem(0);
              box-sizing: border-box;
            }
            select {
              border: 1px solid $inputBoder;
              text-indent: pxToRem(18);
              font-size: pxToRem(24);
              padding: pxToRem(16) 0;
              height: pxToRem(66);
              outline: none;
              margin-top: pxToRem(18);
              -webkit-appearance:none;
              border-radius: pxToRem(0);
              box-sizing: border-box;
            }
            .fullInput {
              width: 96%;
              margin-left: 4%;
            }

            .harfInput {
              width: 66%;
              margin-left: 4%;
              vertical-align: middle;
            }
            .required_mark {
              color: $commonRed;
              position: absolute;
              margin-left: pxToRem(0);
              margin-top: pxToRem(38);
              font-size: pxToRem(28);

            }

            .sendCodeBtn {
              width: 30%;
              color: #fff;
              height: pxToRem(66);
              font-size: pxToRem(20);
              padding: pxToRem(20) 0;
              border: 0;
              outline: none;
              cursor: pointer;
              vertical-align: middle;
              box-sizing: border-box;
              margin-top: pxToRem(18);
            }
            .changeMobile {
              color:$commonRed;
            }
            .hasSend {
              background-color: $codeBg;
              border: 1px solid $codeBg;
            }
            .canChange {
              background-color:#fff;
            }
            .noSend {
              background-color: $commonRed;
              border: 1px solid $commonRed;
            }
            .err-box{
              text-align: left;
              width: 90%;
              margin:  0 auto;
              padding: pxToRem(18) 0 0 pxToRem(18);
              font-size: pxToRem(24);
            }
            .error-text{
              display: block;
              color: $commonRed;
            }
          }

          .register-btn-box {
            text-align: center;
            padding-bottom: pxToRem(35);

            .register-btn {
              display: block;
              width: pxToRem(290);
              height: pxToRem(70);
              color: #fff;
              background-color: $commonRed;
              border: none;
              font-size: pxToRem(24);
              border-radius: pxToRem(0);
              margin: pxToRem(25) auto pxToRem(13) auto;
              cursor: pointer;
              outline: none;
            }

            .tapRegister {
              font-size: pxToRem(22);
              color: $color;
              a {
                cursor: pointer;
                text-decoration: none;
                border-bottom: 1px solid #666666;
              }
            }
          }
        }

        .reg-footer {

        }
      }

      .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        background: rgba(0, 0, 0, .5);
      }
    }
  }

</style>